import Vue from 'vue';
const $t = Vue.prototype.$t

export const starItems = [
  // $t('Any'),
  {text: $t('StarEconomic'), subText: $t('Economic'), value: 2},
  {text: $t('StarComfort'), subText: $t('ComfortHotel_1'), value: 3},
  {text: $t('StarPremium'), subText: $t('PremiumHotel_1'), value: 4},
  {text: $t('StarLuxury'), subText: $t('LuxuryHotel_1'), value: 5},
]
export const priceFilterItems = [
  {text: $t('Price150'), value: 1, min: 0, max: 150},
  {text: '￥150-300', value: 2, min: 150, max: 300},
  {text: '￥300-450', value: 3, min: 300, max: 450},
  {text: '￥450-600', value: 4, min: 450, max: 600},
  {text: '￥600-1000', value: 5, min: 600, max: 1000},
  {text: $t('PriceOver1000'), value: 6, min: 1000, max: 1050}, // max 向上不限
]
export const intlPriceFilterItems = [
  {text: $t('Price400'), value: 1, min: 0, max: 400},
  {text: '￥400-700', value: 2, min: 400, max: 700},
  {text: '￥700-1000', value: 3, min: 700, max: 1000},
  {text: '￥1000-1300', value: 4, min: 1000, max: 1300},
  {text: '￥1300-1800', value: 5, min: 1300, max: 1800},
  {text: $t('PriceOver1800'), value: 6, min: 1800, max: 1900}, // max 向上不限
]

export const interStarFilterItems = [
  {text: $t('StarEconomic_1'), subText: $t('Economic'), value: 2},
  {text: $t('StarComfort_1'), subText: $t('ComfortHotel_1'), value: 3},
  {text: $t('StarPremium_1'), subText: $t('PremiumHotel_1'), value: 4},
  {text: $t('StarLuxury_1'), subText: $t('LuxuryHotel_1'), value: 5},
]

export const getStarTexts = (StarRate, isIntelHotel) => {
  let StarRateList = StarRate ? StarRate.split(',') : []
  let starFilters = isIntelHotel ? interStarFilterItems : starItems
  let starTexts = starFilters.filter((m) => StarRateList.findIndex(v => Number(v) !== 0 && Number(v) === m.value) >= 0).map(v => v.text)
  return starTexts
}

/** 根据选中项 获取展示项 */
export const mixinHotelGetPriceAndStar = (StarRate, item, isIntelHotel) => {
  let StarRateList = StarRate ? StarRate.split(',') : []
  let starFilters = isIntelHotel ? interStarFilterItems : starItems
  let starRateStr = starFilters.filter((m) => StarRateList.findIndex(v => Number(v) !== 0 && Number(v) === m.value) >= 0).map(v => v.text).join(',')
  let priceStr = getPriceDes([item.LowRate, item.HighRate])
  if (starRateStr && priceStr) {
    return `${priceStr},${starRateStr}`
  }
  return `${priceStr}${starRateStr}`
}

/** 根据选中的价格 更新滑块的值 */
export const getPriceRangeMinAndMax = (priceFilterItemsIndex, isInterHotel) => {
  let list = isInterHotel ? intlPriceFilterItems: priceFilterItems
  let item = list.find(v => v.value === priceFilterItemsIndex)
  if (item) {
    return {
      ...item
    }
  }
}

/** 根据价格区间 显示价格描述 */
export const getPriceDes = (range, maxPrice= 1050) => {
  let val1 = range[0] || 0
  let val2 = range[1] || maxPrice
  let str = `￥${val1} - ￥${val2}`
  if (val1 === 0 && val2 === maxPrice) {
    str = ''
  } else if (val1 === 0) {
    str = $t('RMBPriceUnder_x', 'function', [val2])
  } else if (val2 === maxPrice) {
    str = $t('RMBPriceOver_x', 'function', [val1])
  }
  return str
}

/** 判断是否为相同的价格区间 */
export const isSamePriceRange = (val1, val2) => {
  return Number(val1.min) === Number(val2[0]) && Number(val1.max) === Number(val2[1])
}

/** 更具 LowRate HighRate 匹配 PriceFilterItemsIndex */
export const getPriceFilterItemsIndex = (LowRate, HighRate) => {
  if (LowRate === 0 && HighRate === undefined) {
    return 0
  } else if (LowRate === 0 && HighRate === 150) {
    return 1
  } else if (LowRate === 150 && HighRate === 300) {
    return 2
  } else if (LowRate === 300 && HighRate === 450) {
    return 3
  } else if (LowRate === 450 && HighRate === 600) {
    return 4
  } else if (LowRate === 600 && HighRate === 1000) {
    return 5
  } else if (LowRate === 1000 && HighRate === undefined) {
    return 6
  }
  return undefined
}
